import React, { useEffect, useMemo, useState } from 'react';
import ListPageLayout from '../Components/ui/ListPageLayout';
import DataTable from '../Components/ui/DataTable';
import { getDecryptedData } from '../utils/authStorage';
import { getTlHome } from '../services/dashboardService';
import { getApiErrorMessage } from '../utils/apiError';

const normalizeTeamMembers = (tlHome) => {
  const team = tlHome?.Team || tlHome?.teamMembers || tlHome?.TeamMembers || [];
  return (Array.isArray(team) ? team : []).filter((member) => member?.Status !== 'InActive');
};

function TeamLeadRecruiters() {
  const userId = getDecryptedData('Id');
  const [recruiters, setRecruiters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    if (!userId) return;
    const load = async () => {
      setLoading(true);
      setLoadError('');
      try {
        const tlHome = await getTlHome(userId);
        setRecruiters(normalizeTeamMembers(tlHome));
      } catch (error) {
        setLoadError(getApiErrorMessage(error, 'Failed to load assigned recruiters.'));
        setRecruiters([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [userId]);

  const columns = useMemo(() => [
    { key: 'EmpCode', label: 'Emp Code', sortable: true },
    { key: 'EmployeeName', label: 'Name', sortable: true },
    { key: 'Email', label: 'Email', sortable: true },
    { key: 'Status', label: 'Status', sortable: true },
  ], []);

  const tableData = recruiters.map((member) => ({
    id: member._id,
    EmpCode: member.EmpCode || '—',
    EmployeeName: member.EmployeeName || '—',
    Email: member.Email || '—',
    Status: member.Status || '—',
  }));

  return (
    <ListPageLayout
      title="Assigned Recruiters"
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Assigned Recruiters' },
      ]}
      subtitle="Recruiters assigned to your team by an administrator."
      backTo="/dashboard"
      error={loadError}
    >
      {loading && <p className="hr-empty-state">Loading recruiters...</p>}
      {!loading && !loadError && recruiters.length === 0 && (
        <p className="hr-empty-state">
          No recruiters assigned to your team yet. Ask an admin to assign recruiters via Edit User → Assign Team.
        </p>
      )}
      {!loading && recruiters.length > 0 && (
        <DataTable
          columns={columns}
          data={tableData}
          searchPlaceholder="Search by name, email, or code"
          exportFileName="assigned-recruiters"
        />
      )}
    </ListPageLayout>
  );
}

export default TeamLeadRecruiters;
